interface VirusScannerConfig {
  maxUploadSize: number;
}

const virusScannerConfig: VirusScannerConfig = {
  maxUploadSize: 100 * 1024 * 1024, // 100MB
};

export default virusScannerConfig;
